function initTestimonialSlider() {
    let $testimonialSlider = $('.testimonial-slider__content');

    $testimonialSlider.each(function (key, item) {
        if(this.id === '' || this.id === undefined) {
            var sliderIdName = 'testimonial-slider' + key;
            this.id = sliderIdName;
            var sliderId = '#' + sliderIdName;

            $(sliderId).slick({
                dots: false,
                infinite: true,
                speed: 1000,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                arrows: true,
                mobileFirst: false
            });
        }
    });
}

$(function () {
    initTestimonialSlider();
});
